import { useTranslation } from "react-i18next";
import "./Navbar.scss";
import { useClientSideLocaleChange } from "../hooks/useClientSideLocaleChange";
import { Nav } from "react-bootstrap";
import { LanguageSwitcher } from "./LanguageSwitcher/LanguageSwitcher";

interface NavBarLoggedOutViewProps {
  onSignUpClicked: () => void;
  onLogInClicked: () => void;
}

const NavBarLoggedOutView = ({
  onSignUpClicked,
  onLogInClicked,
}: NavBarLoggedOutViewProps) => {
  const { t } = useTranslation();
  const localeSetMutation = useClientSideLocaleChange();

  const setLocale = async (key: string) => {
    await localeSetMutation.mutateAsync(key);
  };

  return (
    <>
      <Nav>
        <LanguageSwitcher onChange={setLocale} />
      </Nav>
      <Nav className="buttonContainer">
        <button
          className="navbarButton outlinedButton"
          onClick={onSignUpClicked}
        >
          {t("common.signup")}
        </button>
        <button className="navbarButton filledButton" onClick={onLogInClicked}>
          {t("common.login")}
        </button>
      </Nav>
    </>
  );
};

export default NavBarLoggedOutView;
